
jQuery(document).ready(function($){
    $(".menu-toggle").on("click", function(e) {
        if($("#mainNav").hasClass("open")) {
            $("#mainNav").removeClass("open");
            $("body").removeClass("overflow-hidden");            

        } else {
            $("#mainNav").addClass("open");
            $("body").addClass("overflow-hidden");            
        }
    });

    $("#mainNav .nav-link").on("click", function(e) {
        if($("body").hasClass("overflow-hidden")) {
            $("body").removeClass("overflow-hidden");            
        }
        
        if($("#mainNav").hasClass("open")) {
            $("#mainNav").removeClass("open");
            $("body").removeClass("overflow-hidden");
        }
    });

    $(window).on("scroll", function () {
        if ($(window).scrollTop()) {
            $('#mainNav').addClass('scroll');
        } else {
            $('#mainNav').removeClass('scroll');
        }
    });

    $('.hero-arrow').click(function (event) {
        event.preventDefault();
        var targetId = $(this).attr('href');
        $('html, body').animate({
          scrollTop: $(targetId).offset().top
        }, 300);
    });
}); 